import React, { useEffect, useState } from "react";
import binanceLogo from "../../images/binanceLogo.png";
import bitfinexLogo from "../../images/bitfinexLogo.png";
import bitmexLogo from "../../images/bitmexLogo.png";
import okxLogo from "../../images/okxLogo.png";
import bybitLogo from "../../images/bybitLogo.png";
import dollarIco from "../../images/dollarIco.png";
import api from "../../api";
import { Loader } from "../global/loader";
import { Pagination, Stack } from "@mui/material";

const coinList = [
  {
    timeframe: "1h",
  },
  {
    timeframe: "4h",
  },
];

export const VolatilityIndex = () => {
  const [selectedTime, setSelectedTime] = useState("4h");
  const [volatilityData, setVolatilityData] = useState([]);
  const [loader, setLoader] = useState(true);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [noOfPost, setNoOfPost] = useState(0);

  const getMarketLiquidity = async () => {
    try {
      let payload = {
        timeframe: selectedTime,
      };
      setLoader(true);
      const resp = await api.getVolatilityIndex(payload);
      // console.log(resp);
      if (resp?.data) {
        setVolatilityData(resp?.data);
        setNoOfPost(resp.data.length); // total count
      }
      setLoader(false);
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    getMarketLiquidity();
    setPage(1); // reset to page 1 when timeframe changes
  }, [selectedTime]);

  // slice the data based on pagination
  const paginatedData = volatilityData.slice((page - 1) * limit, page * limit);

  return (
    <div className="liquidityMain">
      <div className="selectCoin">
        <h5 className="me-2 mb-2">Volatility Index</h5>
        <div className="timeframeRow">
          {["d", "4h", "1h", "30m", "15m"].map((time) => (
            <div
              key={time}
              className={selectedTime === time ? "val active" : "val"}
              onClick={() => setSelectedTime(time)}
            >
              {time.toUpperCase()}
            </div>
          ))}
        </div>
      </div>
      <div className="descrip mb-2">
        Volatility index is a measure of the price movement of a cryptocurrency.
        It is calculated by taking the average of the price movement of a
        cryptocurrency over a period of time.
      </div>
      <Table
        data={paginatedData || []}
        setPage={setPage}
        page={page}
        noOfPost={noOfPost}
        limit={limit}
      />

      {loader && <Loader />}
    </div>
  );
};

const Table = ({ data, page, setPage, noOfPost, limit }) => {
  function formatNumber(num) {
    const isNegative = num < 0;
    const absNum = Math.abs(num);

    let formatted;
    if (absNum >= 1_000_000_000) {
      formatted = (absNum / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (absNum >= 1_000_000) {
      formatted = (absNum / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (absNum >= 1_000) {
      formatted = (absNum / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
    } else {
      formatted = absNum.toString();
    }

    return isNegative ? `-${formatted}` : formatted;
  }

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent pt-0 px-0 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="sticky-col-head">
                    Name
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">24h Change %</div>
                  </th>
                  <th scope="col" className="">
                    Volatility
                  </th>
                  <th scope="col" className="">
                    Price
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Avg. Price</div>
                  </th>
                  <th scope="col" className="">
                    Volume
                  </th>
                  <th scope="col" className="">
                    <div className="w-max">Volume Change</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td scope="row" className="sticky-col">
                      <div className="table-text-dark w-max-c db">
                        {item?.pair}
                      </div>
                    </td>
                    <td scope="row">
                      <div
                        className={
                          item?.change < 0
                            ? "table-text-dark w-max-c db color-red"
                            : "table-text-dark w-max-c db color-green"
                        }
                      >
                        {item?.change}
                      </div>
                    </td>

                    <td scope="row">
                      <div className="w-max-c db ">{item?.volatility}</div>
                    </td>
                    <td scope="row">
                      <div className="w-max-c db ">{item?.price}</div>
                    </td>
                    <td scope="row">
                      <div className="w-max-c db ">{item?.avg_price}</div>
                    </td>
                    <td scope="row">
                      {item?.pair ? (
                        <div className="w-max-c db ">
                          {item?.volume && formatNumber(item?.volume)}{" "}
                          {item?.pair.split("-")[1]}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td scope="row">
                      <div className="w-max-c db ">{item?.volume_change}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfPost / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};
